module.exports = __webpack_public_path__ + "static/media/18ECA38.3d5eb6d4.jpg";